import { render, staticRenderFns } from "./RestaurantPreloader.vue?vue&type=template&id=0bbee910&scoped=true&"
import script from "./RestaurantPreloader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RestaurantPreloader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RestaurantPreloader.vue?vue&type=style&index=0&id=0bbee910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbee910",
  null
  
)

export default component.exports